import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { IResultReportm } from 'src/app/models/reports/report.model';
import { IResultClosedRa } from 'src/app/models/reports/closed-ra.model';
import { IResultClosedGap } from 'src/app/models/reports/closed-gap.model';
import {IResultBonusResumen} from "../../../models/reports/bonus-resumen.model";
import {IResultBonusDetail} from "../../../models/reports/bonus-detail.model";
import {IResultTsm} from "../../../models/reports/tsm.model";
import {IResultTsmSummary} from "../../../models/reports/tsm-summary.model";
import {IResultCis} from "../../../models/reports/cis.model";
import {IResultIma} from "../../../models/reports/ima.model";
import {IResultW30} from "../../../models/reports/w30.model";
import {IResultGeneralSetting, IResultSystemStatus} from "../../../models/general/general-setting.model";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ReportHttpService {
  constructor(private http: HttpClient) {}

  filter(
    wheres: { [key: string]: string },
    selectedTab: string,
    limit: number = 100,
    offset: number = 0,
    sort: string = ''
  ): Observable<IResultReportm> {
    if (selectedTab === 'STAFF LOGIN') {
      return this.getStaffLoginData(wheres, offset, limit, sort);
    }

    // Use new specific endpoints for GIC and RA
    let baseUrl: string;
    switch (selectedTab.toLowerCase()) {
      case 'gic':
        baseUrl = `${environment.apiUrl}/catalog/app_report_gic_v/`;
        break;
      case 'ra':
        baseUrl = `${environment.apiUrl}/catalog/app_report_ra_v/`;
        break;
      case 'appt':
        baseUrl = `${environment.apiUrl}/catalog/app_report_appt_v/`;
        break;
      case 'mwov':
        baseUrl = `${environment.apiUrl}/catalog/app_report_mwov_v/`;
        break;
      case 'siip':
        // SIIP uses different endpoint structure - handled by SIIPDetails method
        const practiceId = wheres['practice_id'] || wheres['billing_tin'] || '';
        const filters = {
          billing_tin: practiceId,
          mco_id__in: wheres['mco_id'] || '',
          limit: limit.toString(),
          offset: offset.toString(),
          ordering: sort
        };
        return this.http.get<IResultReportm>(`${environment.apiUrl}/catalog/bonus_data_chart/`, { params: filters });
      default:
        // Fallback to original pattern for unknown tabs
        baseUrl = `${environment.apiUrl}/catalog/app_report_${selectedTab}_v/`;
    }

    const params = this.buildHttpParams(wheres, offset, limit, sort);
    return this.http.get<IResultReportm>(baseUrl, { params });
  }
  getSettings(
    wheres: { [key: string]: string },
    limit: number = 100,
    offset: number = 0
  ): Observable<IResultGeneralSetting> {
    let params = new HttpParams();

    Object.entries(wheres).forEach(([key, value]) => {
      if (key && value) {
        params = params.append(key, value);
      }
    });

    params = params.append('offset', offset.toString());
    params = params.append('limit', limit.toString());

    return this.http.get<IResultGeneralSetting>(
      `${environment.apiAuthUrl}/security/settings/`,
      { params }
    );
  }


  closedRA(
    wheres: { [key: string]: string } = {},
    limit: number = 100,
    offset: number = 0,
    sort: string = ''
  ): Observable<IResultClosedRa> {
    const params = {
      ...wheres,
      limit: limit.toString(),
      offset: offset.toString(),
      ordering:sort
    };

    return this.http.get<IResultClosedRa>(`${environment.apiUrl}/catalog/closed_ra/`, { params });
  }

  closedGAP(
    wheres: { [key: string]: string } = {},
    limit: number = 100,
    offset: number = 0,
    sort: string = ''
  ): Observable<IResultClosedGap> {
    const params = {
      ...wheres,
      limit: limit.toString(),
      offset: offset.toString(),
      ordering:sort
    };

    return this.http.get<IResultClosedGap>(`${environment.apiUrl}/catalog/closed_gap/`, { params });
  }
  SIIPDetails(
    wheres: { [key: string]: string } = {},
    limit: number = 100,
    offset: number = 0,
    sort: string = ''
  ): Observable<IResultBonusDetail> {
    const params = {
      ...wheres,
      limit: limit.toString(),
      offset: offset.toString(),
      ordering:sort
    };

    return this.http.get<IResultBonusDetail>(`${environment.apiUrl}/catalog/bonus_data_chart/`, { params });
  }
  SIIPResumen(
    wheres: { [key: string]: string } = {},
    limit: number = 100,
    offset: number = 0,
    sort: string = ''
  ): Observable<IResultBonusResumen> {
    const params = {
      ...wheres,
      limit: limit.toString(),
      offset: offset.toString(),
      ordering:sort
    };

    return this.http.get<IResultBonusResumen>(`${environment.apiUrl}/catalog/bonus_chart_summary/`, { params });
  }

  TSMDetails(
    wheres: { [key: string]: string } = {},
    limit: number = 100,
    offset: number = 0,
    sort: string = ''
  ): Observable<IResultTsm> {
    const params = {
      ...wheres,
      limit: limit.toString(),
      offset: offset.toString(),
      ordering: sort
    };
    return this.http.get<IResultTsm>(`${environment.apiUrl}/catalog/tsm_fua_fum_trc/`, { params });
  }

  TSMSummary(
    wheres: { [key: string]: string } = {},
    limit: number = 100,
    offset: number = 0,
    sort: string = ''
  ): Observable<IResultTsmSummary> {
    const params = {
      ...wheres,
      limit: limit.toString(),
      offset: offset.toString(),
      ordering: sort
    };
    return this.http.get<IResultTsmSummary>(`${environment.apiUrl}/catalog/tsm_fua_fum_trc_summary/`, { params });
  }

  CISDetails(
    wheres: { [key: string]: string } = {},
    limit: number = 100,
    offset: number = 0,
    sort: string = ''
  ): Observable<IResultCis> {
    const params = this.buildHttpParams(wheres, offset, limit, sort);
    return this.http.get<IResultCis>(`${environment.apiUrl}/catalog/tsm_cis/`, { params });
  }

  IMADetails(
    wheres: { [key: string]: string } = {},
    limit: number = 100,
    offset: number = 0,
    sort: string = ''
  ): Observable<IResultIma> {
    const params = this.buildHttpParams(wheres, offset, limit, sort);
    return this.http.get<IResultIma>(`${environment.apiUrl}/catalog/tsm_ima/`, { params });
  }

  W30Details(
    wheres: { [key: string]: string } = {},
    limit: number = 100,
    offset: number = 0,
    sort: string = ''
  ): Observable<IResultW30> {
    const params = this.buildHttpParams(wheres, offset, limit, sort);
    return this.http.get<IResultW30>(`${environment.apiUrl}/catalog/tsm_w30/`, { params });
  }

  checkPracticeCapabilities(practiceId: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/accounts/practice/${practiceId}/check/`);
  }

  getKpiData(practiceId: string, kpiType?: string): Observable<any> {
    let params = new HttpParams().set('practice_id', practiceId);

    if (kpiType) {
      params = params.set('kpi_type', kpiType);
    }

    return this.http.get(`${environment.apiUrl}/catalog/app_report_kpi/`, { params });
  }

  private buildHttpParams(
    wheres: { [key: string]: string },
    offset: number,
    limit: number,
    sort: string
  ): HttpParams {
    let params = new HttpParams();

    // Solo agregar parámetros que tengan valores no vacíos o null
    Object.entries(wheres).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value.toString().trim() !== '') {
        params = params.append(key, value);
      }
    });

    params = params.append('offset', offset.toString());
    params = params.append('limit', limit.toString());

    if (sort && sort.trim() !== '') {
      params = params.append('ordering', sort);
    }

    return params;
  }

  private getStaffLoginData(
    wheres: { [key: string]: string },
    offset: number,
    limit: number,
    sort: string = ''
  ): Observable<IResultReportm> {
    const url = `${environment.apiUrl}/accounts/account_list/`;

    let params = new HttpParams()
      .set('expand', 'practice,role,user')
      .set('fields', 'is_verified,practice.name,role.name,id,full_name,user.email,user.last_login')
      .set('practice_id', wheres['practice_id'] || '');

    if (sort && sort.trim() !== '') {
      params = params.set('ordering', sort);
    }

    const staffFilters = {
      name: (wheres['full_name__icontains'] || '').trim().toLowerCase(),
      email: (wheres['user__email__icontains'] || '').trim().toLowerCase(),
      role: (wheres['role__name__icontains'] || '').trim().toLowerCase(),
      lastLogin: (wheres['user__last_login__icontains'] || '').trim()
    };
    const active = Object.entries(staffFilters).filter(([, value]) => value !== '');

    if (active.length === 0) {
      params = params
        .set('offset', offset.toString())
        .set('limit', limit.toString());
      return this.http.get<IResultReportm>(url, { params });
    }

    const [activeKey, activeValue] = active[0];
    const serverSearchable = active.length === 1 && (
      activeKey === 'email' ||
      activeKey === 'role' ||
      (activeKey === 'name' && !activeValue.includes(' '))
    );

    if (serverSearchable) {
      params = params
        .set('search', activeValue)
        .set('offset', offset.toString())
        .set('limit', limit.toString());
      return this.http.get<IResultReportm>(url, { params });
    }

    params = params.set('offset', '0').set('limit', '1000');
    return this.http.get<IResultReportm>(url, { params }).pipe(
      map((data: IResultReportm) => {
        const matches = (data?.results ?? []).filter((row: any) => {
          const name = (row?.full_name || '').toLowerCase();
          const email = (row?.user?.email || '').toLowerCase();
          const role = (row?.role?.name || '').toLowerCase();
          const lastLogin = row?.user?.last_login || '';
          return (!staffFilters.name || name.includes(staffFilters.name))
            && (!staffFilters.email || email.includes(staffFilters.email))
            && (!staffFilters.role || role.includes(staffFilters.role))
            && (!staffFilters.lastLogin || lastLogin.startsWith(staffFilters.lastLogin));
        });
        return {
          ...data,
          count: matches.length,
          results: matches.slice(offset, offset + limit)
        };
      })
    );
  }
}
